import React, { createContext, useContext, ReactNode } from 'react';
import { useSocket } from '../hooks/useSocket';

interface SocketContextType {
  socket: any;
  isConnected: boolean;
  activeUsers: any[];
  typingUsers: any[];
  userCursors: any[];
  joinProject: (projectId: string) => void;
  leaveProject: (projectId: string) => void;
  sendTyping: (projectId: string, context: string, isTyping: boolean) => void;
  sendCursorUpdate: (projectId: string, field: string, position: { x: number; y: number }, selection?: { start: number; end: number }) => void;
  sendSessionUpdate: (projectId: string, data: any) => void;
  sendComment: (projectId: string, data: any) => void;
  sendUploadProgress: (projectId: string, sessionId: string, progress: number) => void;
}

const SocketContext = createContext<SocketContextType | undefined>(undefined);

export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocketContext must be used within a SocketProvider');
  }
  return context;
};

interface SocketProviderProps {
  children: ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const socketData = useSocket({ autoConnect: true });

  return (
    <SocketContext.Provider value={socketData}>
      {children}
    </SocketContext.Provider>
  );
};